import React from 'react';
import { ContentFrame, ScreenContainer } from '@pinwheel/origami';
import ModalHeader from '../components/ModalHeader';
import Loading from '../LinkApiRouter/components/Loading';
import { useAppSelector } from '../state';
import { selectLinkApiResponse } from '../state/slices/slice-link-api';
var useLinkApiLoadingText = function (text) {
    var response = useAppSelector(selectLinkApiResponse);
    if (text)
        return text;
    if ((response === null || response === void 0 ? void 0 : response.responseType) !== 'processing')
        return undefined;
    return response.title;
};
var LoadingView = function (_a) {
    var hideModalHeader = _a.hideModalHeader, text = _a.text;
    var loadingText = useLinkApiLoadingText(text);
    return (React.createElement(ScreenContainer, { "data-testid": "LoadingView" },
        hideModalHeader ? null : React.createElement(ModalHeader, null),
        React.createElement(ContentFrame, null,
            React.createElement("div", { style: {
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                } },
                React.createElement(Loading, { text: loadingText })))));
};
export default LoadingView;
